import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { venueStatusPageConfig } from "./venueStatusPageConfig";

export const venueStatusRecordDefinition: RecordDefinition = {
  path: "/venue-status",
  entityName: "dwhomestatus",
  listRoute: "/venue-statuses",
  backTitle: "Back to venue statuses",
  allowedRoles: administratorRoles,
  config: venueStatusPageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Venue Status",
    newRecordTitle: "New Venue Status",
  },
};
